'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uploads = require('helpers/uploads');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadStatusBaseClass = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(UploadStatusBaseClass, _Component);

  function UploadStatusBaseClass(props) {
    var _text;

    (0, _classCallCheck3.default)(this, UploadStatusBaseClass);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UploadStatusBaseClass.__proto__ || (0, _getPrototypeOf2.default)(UploadStatusBaseClass)).call(this, props));

    var t = require('i18n-universal').getT();
    var text = (_text = {}, (0, _defineProperty3.default)(_text, _uploads.STATUS.DELETING, t('Deleting')), (0, _defineProperty3.default)(_text, _uploads.STATUS.PAUSED, t('Paused')), (0, _defineProperty3.default)(_text, _uploads.STATUS.QUEUED, t('Queued')), (0, _defineProperty3.default)(_text, _uploads.STATUS.UPLOAD_RETRYING, t('Retrying')), (0, _defineProperty3.default)(_text, _uploads.STATUS.SUBMITTING, t('Submitting')), (0, _defineProperty3.default)(_text, _uploads.STATUS.UPLOADING, t('Uploading')), (0, _defineProperty3.default)(_text, _uploads.STATUS.UPLOAD_FAILED, t('Failed')), (0, _defineProperty3.default)(_text, _uploads.STATUS.UPLOAD_SUCCESSFUL, t('Completed')), (0, _defineProperty3.default)(_text, 'processing', t('Processing')), _text);

    _this.state = {
      bytesUploaded: null,
      hidden: props.hideBeforeStart,
      isCanceled: false,
      isComplete: false,
      isFailed: false,
      progress: null,
      status: '',
      statusText: '',
      text: (0, _assign2.default)({}, text, props.text || {}),
      totalSize: null
    };

    _this._createEventHandlers();
    return _this;
  }

  (0, _createClass3.default)(UploadStatusBaseClass, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.uploader.on('statusChange', this._trackStatusEventHandler);
      this.props.uploader.on(this._isTotalProgress ? 'totalProgress' : 'progress', this._trackProgressEventHandler);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.text) {
        this.setState({
          text: (0, _assign2.default)({}, this.state.text, nextProps.text)
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unmounted = true;
      this._unregisterEventHandlers();
    }
  }, {
    key: '_unregisterEventHandlers',
    value: function _unregisterEventHandlers() {
      this.props.uploader.off(this._isTotalProgress ? 'totalProgress' : 'progress', this._trackProgressEventHandler);
      this.props.uploader.off('statusChange', this._trackStatusEventHandler);
    }
  }, {
    key: '_updateProgressState',
    value: function _updateProgressState(bytesUploaded, totalSize) {
      this.setState({
        bytesUploaded: bytesUploaded,
        totalSize: totalSize,
        progress: (0, _uploads.getProgress)(bytesUploaded, totalSize)
      });

      if (this.onUpdateProgress) {
        this.onUpdateProgress();
      }
    }
  }, {
    key: '_createEventHandlers',
    value: function _createEventHandlers() {
      var _this2 = this;

      if (this._isTotalProgress) {
        this._trackProgressEventHandler = function (bytesUploaded, totalSize) {
          _this2._updateProgressState(bytesUploaded, totalSize);
        };
      } else {
        this._trackProgressEventHandler = function (id, name, bytesUploaded, totalSize) {
          if (id === _this2.props.id) {
            _this2._updateProgressState(bytesUploaded, totalSize);
          }
        };
      }

      this._trackStatusEventHandler = function (id, oldStatus, newStatus) {
        var state = _this2.state;
        var _props = _this2.props,
            hideOnComplete = _props.hideOnComplete,
            uploader = _props.uploader;

        var isSuccess = (0, _uploads.isUploadSuccess)(newStatus);
        var isFailed = (0, _uploads.isUploadFailed)(newStatus);
        var isCanceled = (0, _uploads.isUploadCanceled)(newStatus);
        var isComplete = (0, _uploads.isUploadComplete)(newStatus);
        var needHide = !state.hidden && hideOnComplete && isComplete;

        if (!_this2._unmounted) {
          if (id === _this2.props.id) {
            var statusText = state.text ? state.text[newStatus] : '';
            _this2.setState({ status: newStatus, statusText: statusText, isComplete: isComplete, isFailed: isFailed, isCanceled: isCanceled, isSuccess: isSuccess });

            if (newStatus === _uploads.STATUS.UPLOADING && state.hidden) {
              _this2.setState({ hidden: false });
            } else if (needHide && !uploader.methods.getInProgress()) {
              _this2.setState({ hidden: true });
            }
          }

          if (_this2.onStatusChange) {
            _this2.onStatusChange(id, oldStatus, newStatus);
          }
        }
      };
    }
  }, {
    key: '_isTotalProgress',
    get: function get() {
      return typeof this.props.id === 'undefined';
    }
  }, {
    key: 'uploadStatus',
    get: function get() {
      var _state = this.state,
          status = _state.status,
          statusText = _state.statusText,
          progress = _state.progress,
          text = _state.text;

      var isProcessing = progress === 100 && status === _uploads.STATUS.UPLOADING;

      var uploadStatus = isProcessing ? text.processing : statusText;
      if (status === _uploads.STATUS.UPLOADING && progress !== 100 && progress !== null) {
        uploadStatus += ' ' + progress + '%';
      }

      if (this._isTotalProgress && progress !== null) {
        uploadStatus = progress + '%';
      }

      return uploadStatus;
    }
  }]);
  return UploadStatusBaseClass;
}(_react.Component), _class.propTypes = {
  hideBeforeStart: _propTypes2.default.bool,
  hideOnComplete: _propTypes2.default.bool,
  id: _propTypes2.default.number,
  text: _propTypes2.default.shape({
    deleting: _propTypes2.default.string,
    paused: _propTypes2.default.string,
    processing: _propTypes2.default.string,
    queued: _propTypes2.default.string,
    retryingUpload: _propTypes2.default.string,
    submitting: _propTypes2.default.string,
    uploading: _propTypes2.default.string,
    uploadFailed: _propTypes2.default.string,
    uploadSuccessful: _propTypes2.default.string
  }),
  uploader: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  hideBeforeStart: false,
  hideOnComplete: false
}, _temp);
exports.default = UploadStatusBaseClass;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/UploadStatusBaseClass.js
// module id = 514
// module chunks = 1